var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.702 96.5516L93.5855 70.9876C92.2565 69.7796 90.51 69.1354 88.7149 69.1909C86.9197 69.2464 85.2164 69.9973 83.9645 71.285L67.4129 88.307C63.4289 87.5461 55.4194 85.0492 47.1747 76.8253C38.93 68.5737 36.4331 60.5435 35.693 56.5871L52.7011 40.0286C53.9905 38.7776 54.7425 37.074 54.798 35.2783C54.8535 33.4826 54.2082 31.7358 52.9985 30.4075L27.4415 2.29821C26.2313 0.965765 24.5495 0.157535 22.753 0.0451771C20.9566 -0.0671811 19.1871 0.525184 17.8204 1.69647L2.81121 14.5684C1.6154 15.7685 0.901653 17.3658 0.805376 19.0573C0.701626 20.7865 -1.27654 61.747 30.4848 93.5221C58.193 121.223 92.9008 123.25 102.46 123.25C103.857 123.25 104.714 123.208 104.943 123.195C106.634 123.1 108.23 122.383 109.425 121.182L122.29 106.166C123.466 104.803 124.062 103.035 123.952 101.239C123.843 99.4427 123.035 97.7605 121.702 96.5516Z",
    fill: "#FFEBEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBg);
export default __webpack_public_path__ + "static/media/phone_bg.d9814984c9ff5ab2829947eeb41793d7.svg";
export { ForwardRef as ReactComponent };